(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["impex-headlines-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var instances = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function ImpexHeadlinesMarquee(root) {
    this.root = root;
    this.raf = 0;
    this.start = 0;
    this.loopWidth = 0;
    this.duration = Math.max(8, parseFloat(root.dataset.speed || '30')) * 1000;
    this.clones = [];
    this.paused = false;
    this.onResize = function () {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.sync.bind(this), 150);
    }.bind(this);
    this.marqueeEl = this.root.querySelector('[data-ihm-marquee]');
    this.onEnter = function () {
      if (isDesktop()) {
        this.paused = true;
      }
    }.bind(this);
    this.onLeave = function () {
      if (isDesktop()) {
        this.paused = false;
      }
    }.bind(this);
    this.mq = window.matchMedia('(min-width: 768px)');
    this.onMq = function () {
      if (!isDesktop()) {
        this.paused = false;
      }
      this.sync();
    }.bind(this);
    if (this.marqueeEl) {
      this.marqueeEl.addEventListener('mouseenter', this.onEnter);
      this.marqueeEl.addEventListener('mouseleave', this.onLeave);
    }
    window.addEventListener('resize', this.onResize);
    if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
    else if (this.mq.addListener) this.mq.addListener(this.onMq);
    this.sync();
  }

  ImpexHeadlinesMarquee.prototype.activeTrack = function () {
    var name = isDesktop() ? 'desktop' : 'mobile';
    return this.root.querySelector('[data-ihm-track="' + name + '"]');
  };

  ImpexHeadlinesMarquee.prototype.marqueeEnabled = function () {
    if (prefersReducedMotion()) return false;
    return isDesktop()
      ? this.root.dataset.marqueeDesktop === 'true'
      : this.root.dataset.marqueeMobile === 'true';
  };

  ImpexHeadlinesMarquee.prototype.progressEnabled = function () {
    return isDesktop()
      ? this.root.dataset.progressDesktop === 'true'
      : this.root.dataset.progressMobile === 'true';
  };

  ImpexHeadlinesMarquee.prototype.clearClones = function () {
    this.clones.forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
    this.clones = [];
  };

  ImpexHeadlinesMarquee.prototype.sync = function () {
    var self = this;
    this.stop();
    this.clearClones();

    var track = this.activeTrack();
    var barWrap = this.root.querySelector('[data-ihm-progress]');
    var bar = this.root.querySelector('[data-ihm-progress-fill]');
    this.track = track;
    this.barWrap = barWrap;
    this.bar = bar;

    if (barWrap) {
      if (this.progressEnabled()) barWrap.removeAttribute('hidden');
      else barWrap.setAttribute('hidden', '');
    }

    if (!track) return;

    var items = track.querySelectorAll('[data-ihm-item]');
    if (!items.length) return;

    track.style.transform = 'translateX(0)';
    if (bar) bar.style.transform = 'scaleX(0)';

    if (!this.marqueeEnabled()) return;

    var viewport = track.parentElement;
    var baseWidth = track.scrollWidth;
    if (baseWidth < 8) return;

    while (track.scrollWidth < viewport.clientWidth * 2 + baseWidth) {
      for (var i = 0; i < items.length; i++) {
        var clone = items[i].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
        track.appendChild(clone);
        self.clones.push(clone);
      }
    }

    this.loopWidth = baseWidth;
    if (isDesktop()) this.loopWidth += 44;
    this.start = performance.now();
    this.tick(this.start);
  };

  ImpexHeadlinesMarquee.prototype.tick = function (now) {
    if (!this.track || !this.loopWidth) return;
    if (!this.paused) {
      var progress = ((now - this.start) % this.duration) / this.duration;
      this.track.style.transform = 'translate3d(' + (-progress * this.loopWidth) + 'px,0,0)';
      if (this.bar && this.progressEnabled()) {
        this.bar.style.transform = 'scaleX(' + progress + ')';
      }
    } else {
      this.start += 16.67;
    }
    this.raf = requestAnimationFrame(this.tick.bind(this));
  };

  ImpexHeadlinesMarquee.prototype.stop = function () {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = 0;
  };

  ImpexHeadlinesMarquee.prototype.destroy = function () {
    this.stop();
    this.clearClones();
    if (this.marqueeEl) {
      this.marqueeEl.removeEventListener('mouseenter', this.onEnter);
      this.marqueeEl.removeEventListener('mouseleave', this.onLeave);
    }
    window.removeEventListener('resize', this.onResize);
    if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
    else if (this.mq.removeListener) this.mq.removeListener(this.onMq);
  };

  function bind(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new ImpexHeadlinesMarquee(root));
  }

  function unbind(root) {
    var inst = instances.get(root);
    if (!inst) return;
    inst.destroy();
    instances.delete(root);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-ihm-root]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-ihm-root]').forEach(unbind);
  });

  document.addEventListener('shopify:section:reorder', function () {
    scan(document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
